import React, { lazy } from "react";
import { docLazyFn } from '@/router/untilFn'

// 沙盒-导航栏
import SandBox from '@/components/SandBox'
// AccountPayable
import UtilityPayment from "@/views/AccountPayable/UtilityPayment"
import UtilityPaymentMonths from "@/views/AccountPayable/UtilityPayment/UtilityPaymentMonths"
// ApprovalSummary
import ApprovalSummary from "@/views/AccountPayable/ApprovalSummary"
import ApprovalSummaryMonthlyTableDetail from "@/views/AccountPayable/ApprovalSummary/ApprovalSumaryMonthlyTableDetail"
import ApprovalSummaryUtilTableDetail from "@/views/AccountPayable/ApprovalSummary/ApprovalSumaryUtilTableDetail"
import ApprovalSummaryPendingTableDetail from "@/views/AccountPayable/ApprovalSummary/ApprovalSumaryPendingTableDetail"
import MaintenanceContractorTableDetail from "@/views/AccountPayable/ApprovalSummary/MaintenanceContractorTableDetail"
import GardenerAPTableDetail from "@/views/AccountPayable/ApprovalSummary/GardenerAPTableDetail"
import MajorProjectTableDetail from "@/views/AccountPayable/ApprovalSummary/MajorProjectTableDetail"
import MaintenanceMonthlyWorkerDetail from "@/views/AccountPayable/ApprovalSummary/MaintenanceMonthlyWorkerDetail"
import MaintenanceMonthlyWorkerSubDetail from "@/views/AccountPayable/ApprovalSummary/MaintenanceMonthlyWorkerSubDetail"
import BusinessLicenseTableDetail from "@/views/AccountPayable/ApprovalSummary/BusinessLicenseTableDetail"
import MaterialListAPDetail from "@/views/AccountPayable/ApprovalSummary/MaterialListAPDetail"
import InsuranceDetail from "@/views/AccountPayable/ApprovalSummary/InsuranceDetail"
// CheckApproval
import CheckApproval from "@/views/AccountPayable/CheckApproval"
import CheckApprovalDetail from "@/views/AccountPayable/CheckApproval/detail"
import CheckApprovalUtilPaymentDetail from "@/views/AccountPayable/CheckApproval/utilPaymentDetail"
import CheckApprovalMaintenanceDetail from "@/views/AccountPayable/CheckApproval/maintenanceDetail"
import CheckApprovalMainContractorDetail from "@/views/AccountPayable/CheckApproval/mainContractorDetail"
import CAGardenerAPDetail from "@/views/AccountPayable/CheckApproval/CAGardenerAPDetail"
import CAMonthlyWorkerDetail from "@/views/AccountPayable/CheckApproval/CAMonthlyWorkerDetail"
import CAMonthlyWorkerSubDetail from "@/views/AccountPayable/CheckApproval/CAMonthlyWorkerSubDetail"
import CABusinessLicenseDetail from "@/views/AccountPayable/CheckApproval/CABusinessLicenseDetail"
import CAMaterialListAPDetail from "@/views/AccountPayable/CheckApproval/CAMaterialListAPDetail"
import CheckMajorProjectTableDetail from "@/views/AccountPayable/CheckApproval/majorProjectTableDetail"
import CAMajorProjectAPDetail from "@/views/AccountPayable/CheckApproval/component/MajorProjectAPDetail"
import CAInsuranceDetail from "@/views/AccountPayable/CheckApproval/CAInsuranceDetail"
// MaintenancePayContractor
import MaintenancePayContractor from '@/views/AccountPayable/MaintenancePayContractor'
import MaintenancePayContractorDetails from '@/views/AccountPayable/MaintenancePayContractor/Details'
import MaintenancePayPUT from '@/views/AccountPayable/MaintenancePayContractor/component/PUTTable'
// vendors
import Vendors from "@/views/AccountPayable/VendorMWorker/tabs"
// BusinessLicense
import BusinessLicense from "@/views/AccountPayable/BusinessLicense"
// Major Project AP
import MajorProjectAP from "@/views/AccountPayable/MajorProjectAP"
// Material List AP
import MaterialListAP from "@/views/AccountPayable/MaterialListAP"
// Mortgage
import Mortgage from "@/views/AccountPayable/Mortgage/tabs"
import ViewLoan from "@/views/AccountPayable/Mortgage/ViewLoan"
// Approved History
import ApprovalHistory from "@/views/AccountPayable/ApprovalHistory"

// BankMortgageRolling
import BankMortgageRolling from "@/views/AccountPayable/BankMortgageRolling"
// insurance
// import Insurance from "@/views/AccountPayable/Insurance"
import Insurance from "@/views/AccountPayable/Insurance/tabs"
import InsuranceEditPolicyPage from "@/views/AccountPayable/Insurance/component/editPolicyPage"
import InsuranceEnterPaymentPage from "@/views/AccountPayable/Insurance/component/enterPaymentPage"
import InsuranceSummary from "@/views/AccountPayable/Insurance/summary"
import InsurancePage from "@/views/AccountPayable/Insurance/component/insurancePage"
// PendingCheck
import PendingCheck from '@/views/AccountPayable/PendingCheck';
// insuranceByProp
import InsuranceByProp from "@/views/AccountPayable/InsuranceByProp"
// GardenerAP
import GardenerAP from "@/views/AccountPayable/GardenerAP"
import GardenerAPMaintenance from "@/views/AccountPayable/GardenerAP/GardenerAPMaintenance"
import MonthlyWorkerAP from "@/views/AccountPayable/MonthlyWorkerAP"

const accountPayable = [
  {
    path: "/AccountPayable",
    element: <SandBox />,
    children: [
      {
        path: "UtilityPayment",
        element: docLazyFn(<UtilityPayment />),
        auth: false
      },
      {
        path: "ApprovalSummary",
        element: docLazyFn(<ApprovalSummary />),
      },
      {
        path: "ApprovalSummaryMonthlyTableDetail",
        element: docLazyFn(<ApprovalSummaryMonthlyTableDetail />),
      },
      {
        path: "ApprovalSummaryUtilTableDetail",
        element: docLazyFn(<ApprovalSummaryUtilTableDetail />),
      },
      {
        path: "ApprovalSummaryPendingTableDetail",
        element: docLazyFn(<ApprovalSummaryPendingTableDetail />),
      },
       {
        path: "MaintenanceContractorTableDetail",
        element: docLazyFn(<MaintenanceContractorTableDetail />),
      },
      {
        path: "GardenerAPTableDetail",
        element: docLazyFn(<GardenerAPTableDetail />),
      },
       {
        path: "MajorProjectTableDetail",
        element: docLazyFn(<MajorProjectTableDetail />),
      },
      {
        path: "MaintenanceMonthlyWorkerDetail",
        element: docLazyFn(<MaintenanceMonthlyWorkerDetail />),
      },
      {
        path: "MaintenanceMonthlyWorkerSubDetail",
        element: docLazyFn(<MaintenanceMonthlyWorkerSubDetail />),
      },
      {
        path: "BusinessLicenseTableDetail",
        element: docLazyFn(<BusinessLicenseTableDetail />),
      },
      {
        path: "MaterialListAPDetail",
        element: docLazyFn(<MaterialListAPDetail />),
      },
      {
        path: "InsuranceDetail",
        element: docLazyFn(<InsuranceDetail />),
      },
      {
        path: "CheckApproval",
        element: docLazyFn(<CheckApproval />),
      },
      {
        path: "CheckApprovalDetail",
        element: docLazyFn(<CheckApprovalDetail />),
      },
      {
        path: "CheckApprovalUtilPaymentDetail",
        element: docLazyFn(<CheckApprovalUtilPaymentDetail />),
      },
      {
        path: "CheckApprovalMaintenanceDetail",
        element: docLazyFn(<CheckApprovalMaintenanceDetail />),
      },
       {
        path: "CheckApprovalMainContractorDetail",
        element: docLazyFn(<CheckApprovalMainContractorDetail />),
      },
      {
        path: "CAGardenerAPDetail",
        element: docLazyFn(<CAGardenerAPDetail />),
      },
      {
        path: "CheckApprovalMonthlyWorkerDetail",
        element: docLazyFn(<CAMonthlyWorkerDetail />),
      },
      {
        path: "CheckApprovalMonthlyWorkerSubDetail",
        element: docLazyFn(<CAMonthlyWorkerSubDetail />),
      },
      {
        path: "CheckApprovalBusinessLicenseDetail",
        element: docLazyFn(<CABusinessLicenseDetail />),
      },
      {
        path: "CAMaterialListAPDetail",
        element: docLazyFn(<CAMaterialListAPDetail />),
      },
      {
        path: "CheckMajorProjectTableDetail",
        element: docLazyFn(<CheckMajorProjectTableDetail />),
      },
      {
        path: "CAMajorProjectAPDetail",
        element: docLazyFn(<CAMajorProjectAPDetail />),
      },
      {
        path: "CAInsuranceDetail",
        element: docLazyFn(<CAInsuranceDetail />),
      },
      {
        path: "MaintenancePayContractor",
        element: docLazyFn(<MaintenancePayContractor />),
      },
      {
        path: "Vendors",
        element: docLazyFn(<Vendors />),
      }, 
      {
        path: "BusinessLicense",
        element: docLazyFn(<BusinessLicense />),
      },
      {
        path: "MajorProjectAP",
        element: docLazyFn(<MajorProjectAP />),
      }, 
      {
        path: "MaterialListAP",
        element: docLazyFn(<MaterialListAP />),
      },
      {
        path: "Mortgage",
        element: docLazyFn(<Mortgage />),
      },
      {
        path: "ViewLoan",
        element: docLazyFn(<ViewLoan />),
      },
      {
        path: "ApprovalHistory",
        element: docLazyFn(<ApprovalHistory />),
      },
      {
        path: "BankMortgageRolling",
        element: docLazyFn(<BankMortgageRolling />),
      }, 
      {
        path: "Insurance",
        element: docLazyFn(<Insurance />),
      },
      {
        path:"InsuranceSummary",
        element:docLazyFn(<InsuranceSummary />)
      },{
        path:"InsurancePage",
        element:docLazyFn(<InsurancePage />)
      },
      {
        path: 'PendingCheck',
        element: docLazyFn(<PendingCheck />),
      },
      {
        path: 'InsuranceByProp',
        element: docLazyFn(<InsuranceByProp />),
      },
      {
        path: 'GardenerAP',
        element: docLazyFn(<GardenerAP />),
      },
      {
        path: 'GardenerAPMaintenance',
        element: docLazyFn(<GardenerAPMaintenance />),
      },
      {
        path: 'MonthlyWorkerAP',
        element: docLazyFn(<MonthlyWorkerAP />),
      },
    ],
  },
  // 不带沙盒
  {
    path: "/AccountPayable/UtilityPayment/UtilityPaymentMonths",
    element: docLazyFn(<UtilityPaymentMonths />),
  },
  {
    path: "/AccountPayable/MaintenancePayContractor/Details",
    element: docLazyFn(<MaintenancePayContractorDetails />),
  },
  {
        path: "/AccountPayable/InsuranceEditPolicyPage",
        element: docLazyFn(<InsuranceEditPolicyPage />),
 }, 
 {
        path: "/AccountPayable/InsuranceEnterPaymentPage",
        element: docLazyFn(<InsuranceEnterPaymentPage />),
      },
     {
        path: "/AccountPayable/MaintenancePayPUT",
        element: docLazyFn(<MaintenancePayPUT />),
      },
];

export default accountPayable;
